import * as React from "react"

import { ColorModeScript } from "@chakra-ui/react"
import { init } from "@fullstory/browser"
import { createRoot } from "react-dom/client"

import { App } from "./src/components/App"

const container = document.getElementById("root")
if (!container) {
  throw new Error("Root element not found")
}
const root = createRoot(container)

init({ orgId: "o-1CBCVA-na1" })

/**
 * Strict Mode is only ever used in development.
 * - `false` prevents double rendering and double logging
 * - `true` provides better error checking
 */
const useStrictMode = false

root.render(
  useStrictMode ? (
    <React.StrictMode>
      <ColorModeScript />
      <App />
    </React.StrictMode>
  ) : (
    <>
      <ColorModeScript />
      <App />
    </>
  )
)
